import React, { createContext, useState, useContext } from 'react';

// Create the context
const EditModeContext = createContext();

// Create a provider component
export const EditModeProvider = ({ children }) => {
    const [editMode, setEditMode] = useState(false);

    return (
        <EditModeContext.Provider value={{ editMode, setEditMode }}>
            {children}
        </EditModeContext.Provider>
    );
};

// Custom hook to use the EditModeContext
export const useEditMode = () => {
    return useContext(EditModeContext);
};
